/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { elasticSearchMetaSchema } from './elastic-search-meta';
import { reputationDetailsSearchResponseDtoSchema } from './reputation-details-search-response-dto';

/** ReadCandidatesReputationDetailsResponse — dark-roast DTO: ReputationDetailsESSearchResponseDto; also used by readOpportunitiesReputationDetails, readUsersReputationDetails */
export const readCandidatesReputationDetailsResponseSchema = z.object({ "data": z.array(z.lazy(() => reputationDetailsSearchResponseDtoSchema)), "meta": z.lazy(() => elasticSearchMetaSchema).nullish() });
export type ReadCandidatesReputationDetailsResponse = z.infer<typeof readCandidatesReputationDetailsResponseSchema>;
